import { camelize } from 'vue';

import { flattenChildren } from '@components/utils';

import type { NTable } from '../interface';

export function convertChildrenToColumn<RecordType>(elements: any[] = []): NTable.NColumn.TColumns<RecordType> {
  const flattenElements = flattenChildren(elements);
  const columns: NTable.NColumn.TColumns<RecordType> = [];

  flattenElements.forEach((element) => {
    if (!element) return;

    const key = element.key;
    const style = element.props?.style || {};
    const cls = element.props?.class || '';
    const props = element.props || {};

    for (const [k, v] of Object.entries(props)) {
      props[camelize(k)] = v;
    }

    const { default: children, ...restSlots } = element.children || {};
    const column = { ...restSlots, ...props, style, class: cls };

    if (key) {
      column.key = key;
    }

    if (element.type?.__CDS_TABLE_COLUMN_GROUP) {
      column.children = convertChildrenToColumn(typeof children === 'function' ? children() : children);
    } else {
      const customRender = element.children?.default;
      column.customRender = column.customRender || customRender;
    }

    columns.push(column);
  });

  return columns;
}

export function getColumnKey<RecordType>(column: NTable.NColumn.IColumn<RecordType>, defaultKey: string): NTable.TKey {
  if ('key' in column && column.key !== undefined && column.key !== null) return column.key;
  if (column.dataIndex)
    return (Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex) as NTable.TKey;
  return defaultKey;
}

export function getColumnPos(index: number, pos?: string): string {
  return pos ? `${pos}-${index}` : `${index}`;
}

export function renderColumnTitle<RecordType>(
  title: NTable.NColumn.TTitle<RecordType>,
  props: NTable.NColumn.ITitleProps<RecordType>
) {
  if (typeof title === 'function') return title(props);
  return title;
}
